var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "div",
        { staticClass: "modal-popup", on: { click: _vm.handleOverlayClick } },
        [
          _c(
            "div",
            {
              staticClass: "popup bluesky-popup",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("div", { staticClass: "bluesky-form" }, [
                _vm._m(0),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("onboarding.bluesky.instruction"))),
                ]),
                _c("div", { staticClass: "bluesky-input-group" }, [
                  _c("label", { staticClass: "input-label" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("onboarding.bluesky.label_handle")) +
                        "\n        "
                    ),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.credentials.handle,
                        expression: "credentials.handle",
                      },
                    ],
                    ref: "handleInput",
                    staticClass: "input-field",
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t(
                        "onboarding.bluesky.placeholder_handle"
                      ),
                    },
                    domProps: { value: _vm.credentials.handle },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleConnect.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.credentials, "handle", $event.target.value)
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "bluesky-input-group" }, [
                  _c("label", { staticClass: "input-label" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("onboarding.bluesky.label_password")) +
                        "\n        "
                    ),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.credentials.password,
                        expression: "credentials.password",
                      },
                    ],
                    staticClass: "input-field",
                    attrs: {
                      type: "password",
                      placeholder: _vm.$t(
                        "onboarding.bluesky.placeholder_password"
                      ),
                    },
                    domProps: { value: _vm.credentials.password },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleConnect.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.credentials,
                          "password",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "buttons" }, [
                  _c(
                    "div",
                    {
                      staticClass: "button btn-outline-primary",
                      on: { click: _vm.handleCancel },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("onboarding.bluesky.button_cancel")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "button btn-primary",
                      class: { loading: _vm.isConnecting },
                      attrs: { disabled: !_vm.canConnect || _vm.isConnecting },
                      on: { click: _vm.handleConnect },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.isConnecting
                              ? _vm.$t("onboarding.bluesky.button_connecting")
                              : _vm.$t("onboarding.bluesky.button_connect")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "page-avatar" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/img/iconsNetwork/ico-bluesky-2x.png"),
            alt: "Bluesky",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }